export const schema = {
  id: 'air-to-water-heat-pump-commissioning',
  name: 'Air-to-Water Heat Pump Commissioning Checklist (MCS MIS 3005)',
  description: 'MCS MIS 3005 compliant commissioning and handover record for Air-to-Water Heat Pumps',
  category: 'HVAC / Renewables',
  sections: [
    {
      id: 'installerDetails',
      title: '1. MCS Certified Installation Company',
      repeatable: false,
      fields: [
        { id: 'companyName', label: 'Company Name', type: 'text', required: true },
        { id: 'mcsNumber', label: 'MCS Registration / Cert No.', type: 'text', required: true },
        { id: 'engineerName', label: 'Lead Engineer Name', type: 'text', required: true },
        { id: 'engineerPhone', label: 'Telephone Number', type: 'tel', required: true },
        { id: 'engineerEmail', label: 'Email Address', type: 'email' }
      ]
    },
    {
      id: 'siteDetails',
      title: '2. Client & Site Location',
      repeatable: false,
      fields: [
        { id: 'clientName', label: 'Client / Homeowner Name', type: 'text', required: true },
        { id: 'installationAddress', label: 'Installation Address', type: 'textarea', required: true },
        { id: 'postCode', label: 'Postcode', type: 'text', required: true },
        { id: 'contactPhone', label: 'Contact Telephone', type: 'tel' },
        { id: 'commissioningDate', label: 'Commissioning Date', type: 'date', required: true }
      ]
    },
    {
      id: 'equipmentSpecification',
      title: '3. Heat Pump & Cylinder Specification',
      repeatable: false,
      fields: [
        { id: 'hpManufacturer', label: 'Heat Pump Manufacturer', type: 'text', required: true },
        { id: 'hpModel', label: 'Heat Pump Model', type: 'text', required: true },
        { id: 'hpSerialNumber', label: 'Serial Number', type: 'text', required: true },
        { id: 'systemType', label: 'System Architecture', type: 'select', options: ['Monobloc', 'Split System'], required: true },
        { id: 'refrigerantType', label: 'Refrigerant Type (e.g. R32, R290, R410A)', type: 'text', required: true },
        { id: 'refrigerantChargeKg', label: 'Factory / Total Charge (kg)', type: 'number' },
        { id: 'gwp', label: 'Refrigerant GWP', type: 'number' },
        { id: 'cylinderMakeModel', label: 'Hot Water Cylinder Make & Model', type: 'text' },
        { id: 'cylinderCapacityLtrs', label: 'Cylinder Capacity (L)', type: 'number' },
        { id: 'bufferVesselCapacityLtrs', label: 'Buffer / Volumiser Tank Size (L)', type: 'number' }
      ]
    },
    {
      id: 'designParameters',
      title: '4. MCS MIS 3005 Design & Hydraulic Parameters',
      repeatable: false,
      fields: [
        { id: 'designHeatLossKw', label: 'Calculated Building Heat Loss (kW)', type: 'number', required: true },
        { id: 'externalDesignTempC', label: 'External Design Temperature (°C)', type: 'number', required: true },
        { id: 'internalDesignTempC', label: 'Internal Design Temperature (°C)', type: 'number', required: true },
        { id: 'designFlowTempC', label: 'Design Flow Temperature (°C)', type: 'number', required: true },
        { id: 'designReturnTempC', label: 'Design Return Temperature (°C)', type: 'number', required: true },
        { id: 'designDeltaTC', label: 'Design Delta T (°C)', type: 'number', required: true },
        { id: 'designFlowRateLpm', label: 'Required Design Flow Rate (L/min)', type: 'number', required: true },
        { id: 'emitterType', label: 'Primary Heat Emitter Type', type: 'select', options: ['Underfloor Heating', 'Low Temp Radiators', 'Fan Coils', 'Mixed UFH & Radiators'], required: true },
        { id: 'weatherCompensationFitted', label: 'Weather Compensation Enabled?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'heatPumpEfficiencyScop', label: 'Design SCoP (Seasonal COP)', type: 'number' }
      ]
    },
    {
      id: 'waterQualityAndAntifreeze',
      title: '5. Primary Water Treatment & Antifreeze Protection',
      repeatable: false,
      fields: [
        { id: 'systemFlushedBS7593', label: 'System Flushed to BS 7593?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'magneticFilterInstalled', label: 'Magnetic System Filter Fitted?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'glycolBrand', label: 'Antifreeze / Glycol Brand & Product', type: 'text', required: true },
        { id: 'glycolConcentrationPct', label: 'Glycol Concentration (% by volume)', type: 'number', required: true },
        { id: 'freezeProtectionTempC', label: 'Freeze Protection Level (°C)', type: 'number', required: true },
        { id: 'refractometerReadingBrix', label: 'Refractometer Reading (°Brix)', type: 'number' },
        { id: 'primaryWaterPh', label: 'System Water pH Reading', type: 'number' },
        { id: 'inhibitorAdded', label: 'Chemical Inhibitor Dosed?', type: 'select', options: ['Yes', 'No'], required: true }
      ]
    },
    {
      id: 'commissioningMeasurements',
      title: '6. Live Commissioning & Operational Readings',
      repeatable: false,
      fields: [
        { id: 'measuredFlowRateLpm', label: 'Measured Primary Flow Rate (L/min)', type: 'number', required: true },
        { id: 'measuredFlowTempC', label: 'Measured Flow Temperature (°C)', type: 'number', required: true },
        { id: 'measuredReturnTempC', label: 'Measured Return Temperature (°C)', type: 'number', required: true },
        { id: 'measuredDeltaTC', label: 'Actual Operating Delta T (°C)', type: 'number', required: true },
        { id: 'expansionVesselPreChargeBar', label: 'Expansion Vessel Pre-Charge (Bar)', type: 'number', required: true },
        { id: 'systemColdPressureBar', label: 'System Cold Fill Pressure (Bar)', type: 'number', required: true },
        { id: 'defrostCycleTested', label: 'Automatic Defrost Tested & Verified?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'dhwDisinfectionConfigured', label: 'Legionella Disinfection (Pasteurisation) Set?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'immersionHeaterTested', label: 'Back-up Immersion Heater Tested?', type: 'select', options: ['Yes', 'No'], required: true }
      ]
    },
    {
      id: 'electricalAndControls',
      title: '7. Electrical & DNO Notification',
      repeatable: false,
      fields: [
        { id: 'dnoNotificationStatus', label: 'DNO Notification Type', type: 'select', options: ['Connect & Notify (G98/G100)', 'Apply to Connect (G99)'], required: true },
        { id: 'dnoReferenceNumber', label: 'DNO Reference / Application No.', type: 'text' },
        { id: 'isolatorInstalledNearOutdoorUnit', label: 'Rotary Isolator Fitted Near Outdoor Unit?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'rcdTypeFitted', label: 'RCD / RCBO Type (e.g. Type A, Type B, Type F)', type: 'text', required: true },
        { id: 'controllerLocation', label: 'User Controller / Thermostat Location', type: 'text', required: true }
      ]
    },
    {
      id: 'handoverAndDeclarations',
      title: '8. Handover Documentation & Declarations',
      repeatable: false,
      fields: [
        { id: 'userManualSupplied', label: 'Manufacturer User Manual Provided?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'controlsDemonstrated', label: 'Operation & Controls Explained to Client?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'mcsHandoverPackProvided', label: 'MCS Handover Documentation Pack Provided?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'engineerComments', label: 'Engineer Notes & Special Instructions', type: 'textarea' },
        { id: 'engineerSignature', label: 'Commissioning Engineer Signature', type: 'signature', required: true },
        { id: 'customerSignature', label: 'Client / Homeowner Acceptance Signature', type: 'signature', required: true }
      ]
    }
  ]
};

export default schema;
